module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "200px"
    }
  }, [_vm._v("\n 我要办事页面\n  ")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-263541dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/DoWork.vue
// module id = 1069
// module chunks = 0